export default __webpack_public_path__ + "static/media/saurav.f10df05d.jpeg";